<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('organizations')">Comercio</inertia-link>
      <span class="text-white font-medium">/ Crear</span> 
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.ruc" :error="form.errors.ruc" class="pr-6 pb-8 w-full lg:w-1/3" label="RUC Comercio" required/>
          <text-input v-model="form.nameCommerce" :error="form.errors.nameCommerce" class="pr-6 pb-8 w-full lg:w-1/3" label="Nombre Comercio" required/>
          <text-input v-model="form.nameRepresentation" :error="form.errors.nameRepresentation" class="pr-6 pb-8 w-full lg:w-1/3" label="Representante" required/>
          <text-input v-model="form.email" type="email" autofocus autocapitalize="off" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-2/6" label="Email" required/>
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-2/6" label="Teléfono" />
          <text-input v-model="form.website" :error="form.errors.website" class="pr-6 pb-8 w-full lg:w-2/6" label="Sitio Web" />
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-2/6" label="Dirección" required/>
          <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-2/6" label="Ciudad" required/>
          <div v-if="$page.props.auth.user.rol != 'Comercio'"  class="container pr-6 pb-8 w-full lg:w-2/6">
            <label style="color: white; font-weight: 700;" class="form-label" >Usuario:</label>
            <v-select style="color: white; background-color: inexinput;" v-model="form.user" :options="userss" value="id" label="label">
            </v-select>
          </div>   
          <text-area-input v-model="form.publicKey" :error="form.errors.publicKey" class="pr-6 pb-8 w-full lg:w-2/2" label="Public Key" />
          <text-area-input v-model="form.privateKey" :error="form.errors.privateKey" class="pr-6 pb-8 w-full lg:w-2/2" label="Private Key" />
           </div>
           <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
        <div class="px-8 py-4 bg-transparent flex justify-end items-center" style="color: black;">
          <button  class="text-inexorange hover:underline" tabindex="-1" type="button" @click="validar">Validar Claves</button>
          <loading-button :loading="form.processing" v-if="habilita" style="color: white;" class="px-10 py-4 btn-indigoOrange ml-auto" type="submit">Crear Comercio</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  metaInfo: { title: 'Crear Comercio' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TextAreaInput,
    vSelect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    users: Array,
  },
  data() {
    return {
      mensagge: '',
      userss: this.users,
      habilita: false,
      form: this.$inertia.form({
        ruc: null,
        nameRepresentation: null,
        nameCommerce: null,
        publicKey: "",
        privateKey: "",
        address: null,
        city: null,
        fiat: null,
        country: null,
        phone: null,
        email: null,
        postal_code: null,
        website:null,
        user: null,
        wallet_id: "",
        passphrase: "",
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('organizations.store'))
    },
    async validar() {
      try {
        if(this.form.publicKey=="")
        {
          this.mensagge="Necesitamos una public key";
          return;
        }
        if(this.form.privateKey=="")
        {
          this.mensagge='Necesitamos una private key';
          return;

        }
        axios.post('https://napi.inexlatampay.com/api/public/auth',{
          publicKey: this.form.publicKey,
          privateKey: this.form.privateKey,
          }
          , {
   headers: {
    "Content-Type": "application/json"
        }
      }).then(res => {
       if(res.status==200)
       {
        this.mensagge='Claves válidas para su uso';
        this.habilita= true;
       }
      }).catch(err => {
        this.mensagge='Revise claves son erroneas';

      });
      } catch (error) {
        console.log(error);
      }
    },
  },
}
</script>
